import styled from "styled-components";
import {useEffect, useState} from "react";
import {apiFetch} from "../../util";
import {schemas} from "../../../config";
import Select from "react-select";
import {OptionI, plainOption, TableI} from "../../../Types";
import {selectMapColourStylesSingle} from "../../filters/FilterMultiMapValue";
import {BackTable, setBackTableEthereal} from "../../../features/schemaManageSlice";
import {useAppDispatch} from "../../../hooks";


export default function CreateNewBackTableSchema({projectName}: { projectName: string }) {

    const [state, setState] = useState({
        schemaNames: undefined as OptionI[] | undefined,
        selectedSchema: undefined as OptionI | undefined,
        tableNames: undefined as OptionI[] | undefined,
        selectedTableName: undefined as OptionI | undefined,
        initialTable: undefined as BackTable | undefined,
        newKey: '',
        loading: false,
        error: ''
    });

    const backend = schemas[projectName].backend;

    const dispatch = useAppDispatch();

    // --- 1. Load schema names ---
    useEffect(() => {
        if (state.loading || state.error || state.schemaNames) return;

        setState(prev => ({...prev, loading: true}));

        apiFetch<{
            data: { schemas: string[], defaultSqlSchemaName: string }
        }>(`${backend}/astra/createNewTableSchema.php?command=getSchemasNames&project=${projectName}`)
            .then(({body: {data}, error, success}) => {
                if (success) {
                    setState(prev => ({
                        ...prev,
                        schemaNames: data.schemas.map(s => ({label: s, value: s})),
                        selectedSchema: plainOption(data.defaultSqlSchemaName),
                        tableNames: undefined,
                        loading: false,
                        error: ''
                    }));
                } else {
                    setState(prev => ({...prev, loading: false, error: String(error)}));
                }
            });
    }, [backend, projectName, state.schemaNames, state.loading, state.error]);

    // --- 2. Load table names for selected schema ---
    useEffect(() => {
        if (state.loading || state.error || !state.selectedSchema || state.tableNames) return;

        setState(prev => ({...prev, loading: true}));

        apiFetch(
            `${backend}/astra/createNewTableSchema.php?command=getSchemaTableNames&schemaName=${state.selectedSchema.value}`
        ).then(({body, success, error}) => {
            if (success) {
                const options = body.data.map((s: string) => ({label: s, value: s}));
                setState(prev => ({
                    ...prev,
                    tableNames: options,
                    selectedTableName: options.length > 0 ? options[0] : undefined,
                    initialTable: undefined,
                    loading: false,
                    error: ''
                }));
            } else {
                setState(prev => ({...prev, loading: false, error: String(error)}));
            }
        });
    }, [backend, state.selectedSchema, state.tableNames, state.loading, state.error]);

    // --- 3. Load initial table structure ---
    useEffect(() => {
        if (
            state.loading ||
            state.error ||
            !state.selectedSchema ||
            !state.selectedTableName ||
            state.initialTable
        )
            return;

        setState(prev => ({...prev, loading: true}));

        apiFetch<any>(
            `${backend}/astra/createNewTableSchema.php?command=getInitialSchema&schemaName=${state.selectedSchema.value}&tableName=${state.selectedTableName.value}`
        ).then(({body, success, error}) => {
            if (success) {
                setState(prev => ({
                    ...prev,
                    initialTable: body.data,
                    newKey: body.data.name,
                    loading: false,
                    error: ''
                }));
            } else {
                setState(prev => ({...prev, loading: false, error: String(error)}));
            }
        });
    }, [backend, state.selectedSchema, state.selectedTableName, state.initialTable, state.loading, state.error]);

    return (
        <Container>
            <div className="cont">
                <h1>Додати нову схему таблиці</h1>
                {state.error && <div className="error">{state.error}</div>}
                <div>схема.таблиця</div>
                {state.schemaNames && state.selectedSchema && (
                    <div className="sel">
                        <Select<OptionI>
                            options={state.schemaNames}
                            value={state.selectedSchema}
                            onChange={(o) =>
                                setState(prev => ({
                                    ...prev,
                                    selectedSchema: o!,
                                    selectedTableName: undefined,
                                    tableNames: undefined,
                                    initialTable: undefined,
                                    newKey: ''
                                }))
                            }
                            isDisabled={!!state.error || state.loading}
                            styles={selectMapColourStylesSingle}
                        />
                    </div>
                )}
                {state.tableNames && state.selectedTableName && (
                    <div className="sel">
                        <Select<OptionI>
                            options={state.tableNames}
                            value={state.selectedTableName}
                            onChange={(o) =>
                                setState(prev => ({
                                    ...prev,
                                    selectedTableName: o!,
                                    initialTable: undefined,
                                    newKey: ''
                                }))
                            }
                            isDisabled={!!state.error || state.loading}
                            styles={selectMapColourStylesSingle}
                        />
                    </div>
                )}

                {state.initialTable && (
                    <div className="initial">
                        <div>
                            <label>Ключ таблиці - </label>
                            <input
                                type="text"
                                value={state.newKey}
                                onChange={(e) => setState(prev => ({...prev, newKey: e.target.value}))}
                            />
                        </div>
                        <div className="name">Назва таблиці - {state.initialTable.name}</div>
                        <div className="name">Поля - {Object.keys(state.initialTable.fieldsList).join(', ')}</div>
                        <button className="btn-cmn" onClick={() => dispatch(setBackTableEthereal({
                            key: state.newKey,
                            table: state.initialTable!
                        }))}>Додати схему
                        </button>
                    </div>
                )}
            </div>
        </Container>
    );
}

const Container = styled.section`

    display: flex;
    width: 100%;
    justify-content: center;

    & .cont {
        display: flex;
        flex-flow: column;
        gap: .5rem;
        width: 100%;
        align-items: center;
        max-width: 600px;

        line-height: 1.2;

        background-color: hsl(from var(--table-row-odd-bg-color) h s l / 0.6);
        color: var(--table-row-text-color);
        //color: hotpink;
        padding: .5rem;

        .toggle-facet {

        }

        .sel {
            width: 100%;
        }

        .initial {
            display: flex;
            flex-flow: column;
            gap: .5rem;
            width: 100%;

        }
    }




`
